import React, { createContext, useContext } from 'react'
import { OverviewState, useAdvancedOverview } from './useAdvancedOverview'

const AdvancedOverviewContext = createContext<OverviewState>({ status: 'loading' })

export const AdvancedOverviewProvider = ({ uid, children }: { uid?: string; children: React.ReactNode }) => {
  const state = useAdvancedOverview(uid)

  return <AdvancedOverviewContext.Provider value={state}>{children}</AdvancedOverviewContext.Provider>
}

export const useAdvancedOverviewState = () => useContext(AdvancedOverviewContext)
